import { Dropdown } from 'react-bootstrap'
import { HorizontalStack, Icon } from '@ztechapps/webui.util'
import { useTheme } from '@ztechapps/common.hook'

export const ToggleColorModeDropdownItem = () => {
  const theme = useTheme()
  const { isDark, toggle } = theme.colorMode

  return (
    <Dropdown.Item onClick={() => toggle()}>
      <HorizontalStack gap={1}>
        <Icon name={!isDark ? 'sun' : 'moon'} />
        <span> {!isDark ? 'Dark' : 'Light'} mode </span>
      </HorizontalStack>
    </Dropdown.Item>
  )
}
